import { FC } from 'react';
import { StepperField } from '@mews-commander/legacy-form';
import { ProductListProductOwnProps } from '../types';
import { getProductUnitAmountFieldName } from '../utils';

interface ProductListProductUnitAmountFieldProps extends ProductListProductOwnProps {
    allowNegativeValues: boolean;
}

const ProductListProductUnitAmountField: FC<ProductListProductUnitAmountFieldProps> = ({
    productId,
    allowNegativeValues,
}) => <StepperField name={getProductUnitAmountFieldName(productId)} min={allowNegativeValues ? undefined : 0} />;

export default ProductListProductUnitAmountField;
